import { render, staticRenderFns } from "./PublicityEditor2.vue?vue&type=template&id=319857f9&scoped=true"
import script from "./PublicityEditor2.vue?vue&type=script&lang=js"
export * from "./PublicityEditor2.vue?vue&type=script&lang=js"
import style0 from "./PublicityEditor2.vue?vue&type=style&index=0&id=319857f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319857f9",
  null
  
)

export default component.exports